import AnalyticsUtils from "@analytics/AnalyticsUtils";
import enhancedFetch, { normalizeHeaders } from "api/utils/enhancedFetch";

const TANGO_AUTH_USERNAME_HEADER = "X-TangoAuth-Username";

const getHeaderFromObject = (obj: Record<string, unknown>, key: string) => {
  const lowKey = key.toLowerCase();

  return Object.entries(obj).find(([k]) => k.toLowerCase() === lowKey)?.[1];
};

export const acmeFetch = async (
  url: RequestInfo,
  initialOptions: RequestInit,
  username: string
) => {
  const initialHeaders = normalizeHeaders(initialOptions.headers);

  const alreadyInInitial =
    initialHeaders.get(TANGO_AUTH_USERNAME_HEADER) === username;

  const analyticsHeaders = AnalyticsUtils.getHeaders?.() ?? {};
  const alreadyInAnalytics =
    getHeaderFromObject(analyticsHeaders, TANGO_AUTH_USERNAME_HEADER) ===
    username;

  if (alreadyInInitial || alreadyInAnalytics) {
    return enhancedFetch(url, { ...initialOptions, headers: initialHeaders });
  }

  const patchedHeaders = new Headers(initialHeaders);
  patchedHeaders.set(TANGO_AUTH_USERNAME_HEADER, username);

  const patchedOptions: RequestInit = {
    ...initialOptions,
    headers: patchedHeaders,
  };

  return await enhancedFetch(url, patchedOptions);
};
